import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconWallet4: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconWallet4"><Path d="M19.5 6V4.5H3.5C2.94772 4.5 2.5 4.94772 2.5 5.5C2.5 6.05228 2.94772 6.5 3.5 6.5H21.5V19.5H4.5C3.39543 19.5 2.5 18.6046 2.5 17.5V6M18.5 13C18.5 13.5523 18.0523 14 17.5 14C16.9477 14 16.5 13.5523 16.5 13C16.5 12.4477 16.9477 12 17.5 12C18.0523 12 18.5 12.4477 18.5 13Z" stroke="currentColor"/></CentralIconBase>;
});

export default IconWallet4;
